<ng-container *ngIf="loading">
  <div class="w-100 text-center mt-3">
    <img src="./assets/public/images/loading.gif " alt=" " />
  </div>
</ng-container>

  <!-- SECCIÓN 1: INFORMACIÓN BÁSICA -->
  <div class="card mt-3 border-primary">
    <div class="card-header bg-primary bg-opacity-10">
      <div class="d-flex align-items-center">
        <i class="fas fa-info-circle text-primary me-2"></i>
        <h5 class="mb-0 text-primary">
          <span *ngIf="code">Editar</span> 
          <span *ngIf="!code">Nueva</span> 
          Penalidad - Información Básica
        </h5>
      </div>
      <small class="text-secondary mt-1 d-block">
        Configure la información general de la penalidad que se aplicará a los clientes
      </small>
    </div>
    <div class="card-body">
      <form [formGroup]="formInitial">
        <!-- Estatus -->
        <div class="row pt-3">
          <div class="col-6">
            <div class="form-floating">
              <select (blur)="validateField1('status')" 
                      [ngClass]="{'is-invalid': hasError1('status')}" 
                      formControlName="status" 
                      class="form-select" 
                      aria-label="Estatus de la penalidad">
                <option value="ACTIVE">Activa</option>
                <option value="INACTIVE">Inactiva</option>
              </select>
              <label for="status">
                <i class="fas fa-toggle-on me-1"></i>
                Estatus
              </label>
              <div class="form-text">
                <i class="fas fa-lightbulb text-warning me-1"></i>
                <strong>Activa:</strong> La penalidad estará disponible para aplicarse. 
                <strong>Inactiva:</strong> La penalidad no se aplicará aunque tenga reglas configuradas.
              </div>
              <div *ngIf="hasError1('status')" class="text-danger small mt-1">
                {{ getErrorMessage1('status') }}
              </div>
            </div>
          </div>
        </div>

        <!-- Título y Código -->
        <div class="row pt-3">
          <div class="col-6">
            <div class="form-floating">
              <input (blur)="validateField1('title')" 
                     [ngClass]="{'is-invalid': hasError1('title')}" 
                     type="text" 
                     formControlName="title" 
                     class="form-control" 
                     placeholder="Ej: Penalidad por Mora" />
              <label for="title">
                <i class="fas fa-tag me-1"></i>
                Título de la Penalidad
              </label>
              <div class="form-text">
                <i class="fas fa-lightbulb text-warning me-1"></i>
                Nombre descriptivo que identifique claramente el propósito de esta penalidad
              </div>
              <div *ngIf="hasError1('title')" class="text-danger small mt-1">
                {{ getErrorMessage1('title') }}
              </div>
            </div>
          </div>
          
          <div class="col-6">
            <div class="form-floating">
              <input (blur)="validateField1('codigo')" 
                     [ngClass]="{'is-invalid': hasError1('codigo')}" 
                     type="text" 
                     formControlName="codigo" 
                     class="form-control" 
                     placeholder="Ej: C001, MORA01" />
              <label for="codigo">
                <i class="fas fa-barcode me-1"></i>
                Código de Penalidad
              </label>
              <div class="form-text">
                <i class="fas fa-lightbulb text-warning me-1"></i>
                Código único para identificar esta penalidad en el sistema (Ej: C001, MORA01)
              </div>
              <div *ngIf="hasError1('codigo')" class="text-danger small mt-1">
                {{ getErrorMessage1('codigo') }}
              </div>
            </div>
          </div>
        </div>
      
        <!-- Descripción -->
        <div class="row pt-3">
          <div class="col-12">
            <div class="form-floating">
              <input (blur)="validateField1('description')" 
                     [ngClass]="{'is-invalid': hasError1('description')}" 
                     type="text" 
                     formControlName="description" 
                     class="form-control" 
                     placeholder="Describa detalladamente cuándo y por qué se aplica esta penalidad" />
              <label for="description">
                <i class="fas fa-align-left me-1"></i>
                Descripción Detallada
              </label>
              <div class="form-text">
                <i class="fas fa-lightbulb text-warning me-1"></i>
                Explique claramente las circunstancias en las que se aplicará esta penalidad
              </div>
              <div *ngIf="hasError1('description')" class="text-danger small mt-1">
                {{ getErrorMessage1('description') }}
              </div>
            </div>
          </div>
        </div>
      
        <!-- Tipo de Aplicación -->
        <div class="row pt-3">
          <div class="form-group col-12">
            <div class="form-floating">
              <select (blur)="validateField1('application_type')" 
                      [ngClass]="{'is-invalid': hasError1('application_type')}" 
                      formControlName="application_type" 
                      class="form-select" 
                      aria-label="Tipo de aplicación">
                <option value="">-- Seleccione el tipo de aplicación --</option>
                <option *ngFor="let category of list_categories" [value]="category._id" [innerHTML]="category.description"></option>
              </select>
              <label for="application_type">
                <i class="fas fa-cogs me-1"></i>
                Tipo de Aplicación
              </label>
              <div class="form-text">
                <i class="fas fa-lightbulb text-warning me-1"></i>
                Define el contexto donde se aplicará la penalidad (cuenta, cuota, etc.)
              </div>
              <div *ngIf="hasError1('application_type')" class="text-danger small mt-1">
                {{ getErrorMessage1('application_type') }}
              </div>
            </div>
          </div>
        </div>
      
        <!-- Frecuencia de Aplicación -->
        <div class="form-group col-12 mt-4">
          <div class="alert alert-info border-info">
            <div class="d-flex align-items-start">
              <i class="fas fa-clock text-info me-2 mt-1"></i>
              <div>
                <h6 class="alert-heading mb-1">Frecuencia de Aplicación</h6>
                <small>Configure con qué frecuencia se puede aplicar esta penalidad al mismo cliente</small>
              </div>
            </div>
          </div>
        </div>
        
        <div class="row">
          <div class="mt-3" [class.col-4]="showFrequencyInputs" [class.col-12]="!showFrequencyInputs">
            <div class="form-floating">
              <select (blur)="validateField1('frequency')" 
                      [ngClass]="{'is-invalid': hasError1('frequency')}" 
                      formControlName="frequency" 
                      class="form-select" 
                      aria-label="Frecuencia de aplicación">
                <option value="">-- Seleccione la frecuencia --</option>
                <option *ngFor="let frecuency of list_fee_frecuencies" [value]="frecuency._id" [innerHTML]="frecuency.description"></option>
              </select>
              <label for="frequency">
                <i class="fas fa-calendar-alt me-1"></i>
                Frecuencia
              </label>
              <div class="form-text">
                <i class="fas fa-lightbulb text-warning me-1"></i>
                Define cada cuánto tiempo se puede aplicar la misma penalidad
              </div>
              <div *ngIf="hasError1('frequency')" class="text-danger small mt-1">
                {{ getErrorMessage1('frequency') }}
              </div>
            </div>
          </div>
          
          <div class="col-4 mt-3" *ngIf="showFrequencyInputs===true">
            <div class="form-floating">
              <select (blur)="validateField1('unit_of_measure')" 
                      [ngClass]="{'is-invalid': hasError1('unit_of_measure')}" 
                      formControlName="unit_of_measure" 
                      class="form-select" 
                      aria-label="Unidad de medida">
                <option value="">-- Seleccione unidad --</option>
                <option *ngFor="let measurement of list_fee_measurements" [value]="measurement._id" [innerHTML]="measurement.description"></option>
              </select>
              <label for="unit_of_measure">
                <i class="fas fa-ruler me-1"></i>
                Unidad de Medida
              </label>
              <div class="form-text">
                <i class="fas fa-lightbulb text-warning me-1"></i>
                Especifica la unidad para medir la frecuencia (días, meses, etc.)
              </div>
              <div *ngIf="hasError1('unit_of_measure')" class="text-danger small mt-1">
                {{ getErrorMessage1('unit_of_measure') }}
              </div>
            </div>
          </div>
          
          <div class="col-4 mt-3" *ngIf="showFrequencyInputs===true">
            <div class="form-floating">
              <input (blur)="validateField1('limit')" 
                     [ngClass]="{'is-invalid': hasError1('limit')}" 
                     type="number" 
                     formControlName="limit" 
                     class="form-control" 
                     placeholder="Ej: 30" />
              <label for="limit">
                <i class="fas fa-hashtag me-1"></i>
                Límite
              </label>
              <div class="form-text">
                <i class="fas fa-lightbulb text-warning me-1"></i>
                Cantidad de unidades para el límite de frecuencia
              </div>
              <div *ngIf="hasError1('limit')" class="text-danger small mt-1">
                {{ getErrorMessage1('limit') }}
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

  <!-- SECCIÓN 2: REGLAS DE APLICACIÓN -->
  <div class="card mt-3 border-success">
    <div class="card-header bg-success bg-opacity-10">
      <div class="d-flex align-items-center">
        <i class="fas fa-list-ul text-success me-2"></i>
        <h5 class="mb-0 text-success">Reglas de Aplicación</h5>
      </div>
      <small class="text-secondary mt-1 d-block">
        Configure las condiciones específicas y tarifas para aplicar esta penalidad
      </small>
    </div>
    <div class="card-body">
      <form [formGroup]="form">
        <!-- Toggle de Condiciones -->
        <div class="form-group col-12 mt-3">
          <div class="alert alert-warning border-warning">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-start">
                <i class="fas fa-filter text-warning me-2 mt-1"></i>
                <div>
                  <h6 class="alert-heading mb-1">¿Aplicar Condiciones Específicas?</h6>
                  <small>Active esta opción si la penalidad debe aplicarse solo cuando se cumplan ciertas condiciones</small>
                </div>
              </div>
              <div class="form-check form-switch">
                <input class="form-check-input fs-5" 
                       type="checkbox" 
                       formControlName="withCondition"
                       role="switch"
                       id="withCondition">
                <label class="form-check-label fw-bold" for="withCondition">
                  Usar Condiciones
                </label>
              </div>
            </div>
          </div>
        </div>

        <!-- Condiciones (solo si está activado) -->
        <ng-container *ngIf="showContainerConditions===true">
          <div class="alert alert-info border-info mb-3">
            <div class="d-flex align-items-start">
              <i class="fas fa-info-circle text-info me-2 mt-1"></i>
              <div>
                <h6 class="alert-heading mb-1">Configuración de Condiciones</h6>
                <small>Defina las condiciones específicas que deben cumplirse para aplicar esta penalidad</small>
              </div>
            </div>
          </div>
          
          <div class="row pt-3">
            <div class="col-3">
              <div class="form-floating">
                <select (blur)="validateField('attribute')" 
                        [ngClass]="{'is-invalid': hasError('attribute')}" 
                        class="form-select" 
                        formControlName="attribute">
                  <option value="">-- Seleccione atributo --</option>
                  <option *ngFor="let attribute of list_fee_attributes" [value]="attribute.key">{{ attribute.value }}</option>
                </select>
                <label>
                  <i class="fas fa-tag me-1"></i>
                  Atributo a Evaluar
                </label>
                <div class="form-text">
                  <i class="fas fa-lightbulb text-warning me-1"></i>
                  Campo del cliente o cuenta que se evaluará
                </div>
                <div *ngIf="hasError('attribute')" class="text-danger small mt-1">
                  {{ getErrorMessage('attribute') }}
                </div>
              </div>
            </div>
            
            <div class="col-3">
              <div class="form-floating">
                <select (blur)="validateField('condition')" 
                        [ngClass]="{'is-invalid': hasError('condition')}" 
                        class="form-select" 
                        formControlName="condition">
                  <option value="">-- Seleccione condición --</option>
                  <option *ngFor="let comparison of list_comparison" [value]="comparison.key" [innerHTML]="comparison.simbol + ' ' +comparison.value "></option>
                </select>
                <label>
                  <i class="fas fa-equals me-1"></i>
                  Tipo de Comparación
                </label>
                <div class="form-text">
                  <i class="fas fa-lightbulb text-warning me-1"></i>
                  Operador de comparación para evaluar el atributo
                </div>
                <div *ngIf="hasError('condition')" class="text-danger small mt-1">
                  {{ getErrorMessage('condition') }}
                </div>
              </div>
            </div>

            <!-- Valores de comparación -->
            <ng-container *ngIf="showBetweenInputs; else singleInput">
              <div class="col-3">
                <div class="form-floating">
                  <input (blur)="validateField('lower_limit')" 
                         [ngClass]="{'is-invalid': hasError('lower_limit')}" 
                         type="text" 
                         class="form-control" 
                         formControlName="lower_limit"
                         placeholder="Ej: 100">
                  <label>
                    <i class="fas fa-arrow-down me-1"></i>
                    Límite Inferior
                  </label>
                  <div class="form-text">
                    <i class="fas fa-lightbulb text-warning me-1"></i>
                    Valor mínimo del rango
                  </div>
                  <div *ngIf="hasError('lower_limit')" class="text-danger small mt-1">
                    {{ getErrorMessage('lower_limit') }}
                  </div>
                </div>
              </div>
              <div class="col-3">
                <div class="form-floating">
                  <input (blur)="validateField('upper_limit')" 
                         [ngClass]="{'is-invalid': hasError('upper_limit')}" 
                         type="text" 
                         class="form-control" 
                         formControlName="upper_limit"
                         placeholder="Ej: 500">
                  <label>
                    <i class="fas fa-arrow-up me-1"></i>
                    Límite Superior
                  </label>
                  <div class="form-text">
                    <i class="fas fa-lightbulb text-warning me-1"></i>
                    Valor máximo del rango
                  </div>
                  <div *ngIf="hasError('upper_limit')" class="text-danger small mt-1">
                    {{ getErrorMessage('upper_limit') }}
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-template #singleInput>
              <div class="col-6">
                <div class="form-floating">
                  <input (blur)="validateField('single_value')" 
                         [ngClass]="{'is-invalid': hasError('single_value')}"  
                         type="text" 
                         class="form-control" 
                         formControlName="single_value"
                         placeholder="Ej: 30">
                  <label>
                    <i class="fas fa-bullseye me-1"></i>
                    Valor de Comparación
                  </label>
                  <div class="form-text">
                    <i class="fas fa-lightbulb text-warning me-1"></i>
                    Valor específico para la comparación
                  </div>
                  <div *ngIf="hasError('single_value')" class="text-danger small mt-1">
                    {{ getErrorMessage('single_value') }}
                  </div>
                </div>
              </div>
            </ng-template>
          </div>
        </ng-container>

        <!-- Sección de Tarifa -->
        <div class="form-group col-12 mt-4">
          <div class="alert alert-success border-success">
            <div class="d-flex align-items-start">
              <i class="fas fa-dollar-sign text-success me-2 mt-1"></i>
              <div>
                <h6 class="alert-heading mb-1">Configuración de Tarifa</h6>
                <small>Configure el monto y tipo de penalidad que se aplicará cuando se cumplan las condiciones</small>
              </div>
            </div>
          </div>
        </div>

        <div class="row pt-3">
          <div class="col-6">
            <div class="form-floating">
              <select (blur)="validateField('commission_type')" 
                      [ngClass]="{'is-invalid': hasError('commission_type')}" 
                      class="form-select" 
                      formControlName="commission_type">
                <option value="">-- Seleccione tipo de penalidad --</option>
                <option *ngFor="let application of list_fee_application_types" [value]="application.code">{{ application.description }}</option>
              </select>
              <label>
                <i class="fas fa-calculator me-1"></i>
                Tipo de Penalidad
              </label>
              <div class="form-text">
                <i class="fas fa-lightbulb text-warning me-1"></i>
                <strong>Fijo:</strong> Monto fijo. <strong>Porcentaje:</strong> % del valor. <strong>Mixto:</strong> Fijo + %
              </div>
              <div *ngIf="hasError('commission_type')" class="text-danger small mt-1">
                {{ getErrorMessage('commission_type') }}
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="form-floating">
              <select (blur)="validateField('currency')" 
                      [ngClass]="{'is-invalid': hasError('currency')}" 
                      class="form-select" 
                      formControlName="currency">
                <option value="USD">USD - Dólares Americanos</option>
                <option value="BS">Bs - Bolívares</option>
              </select>
              <label>
                <i class="fas fa-coins me-1"></i>
                Moneda
              </label>
              <div class="form-text">
                <i class="fas fa-lightbulb text-warning me-1"></i>
                Moneda en la que se expresará el monto de la penalidad
              </div>
              <div *ngIf="hasError('currency')" class="text-danger small mt-1">
                {{ getErrorMessage('currency') }}
              </div>
            </div>
          </div>
        </div>
        
        <div class="row">
          <ng-container *ngIf="showMixedCommission || showFixedCommission">
            <div class="col-6 mt-3">
              <div class="form-floating">
                <input (blur)="validateField('fixed_amount')" 
                       [ngClass]="{'is-invalid': hasError('fixed_amount')}" 
                       type="number" 
                       step="0.01"
                       min="0"
                       class="form-control" 
                       formControlName="fixed_amount"
                       placeholder="Ej: 25.00">
                <label>
                  <i class="fas fa-money-bill me-1"></i>
                  Monto Fijo
                </label>
                <div class="form-text">
                  <i class="fas fa-lightbulb text-warning me-1"></i>
                  Cantidad fija que se cobrará como penalidad
                </div>
                <div *ngIf="hasError('fixed_amount')" class="text-danger small mt-1">
                  {{ getErrorMessage('fixed_amount') }}
                </div>
              </div>
            </div>
          </ng-container>
          
          <ng-container *ngIf="showMixedCommission || showPercentageCommission">
            <div class="col-6 mt-3">
              <div class="form-floating">
                <input (blur)="validateField('percentage')" 
                       [ngClass]="{'is-invalid': hasError('percentage')}" 
                       type="number" 
                       min="0.01" 
                       max="100" 
                       step="0.01"
                       class="form-control" 
                       formControlName="percentage"
                       placeholder="Ej: 5.5">
                <label>
                  <i class="fas fa-percentage me-1"></i>
                  Porcentaje
                </label>
                <div class="form-text">
                  <i class="fas fa-lightbulb text-warning me-1"></i>
                  Porcentaje que se aplicará sobre el valor base (1-100%)
                </div>
                <div *ngIf="hasError('percentage')" class="text-danger small mt-1">
                  {{ getErrorMessage('percentage') }}
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      
        <!-- Vigencia -->
        <div class="form-group col-12 mt-4">
          <div class="alert alert-primary border-primary">
            <div class="d-flex align-items-start">
              <i class="fas fa-calendar-check text-primary me-2 mt-1"></i>
              <div>
                <h6 class="alert-heading mb-1">Período de Vigencia</h6>
                <small>Configure el período durante el cual esta regla estará activa. Si no especifica fecha de fin, la regla será permanente.</small>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-6 mt-3">
            <div class="form-floating">
              <input (blur)="validateField('start_date')" 
                     [ngClass]="{'is-invalid': hasError('start_date')}" 
                     type="date" 
                     class="form-control" 
                     formControlName="start_date">
              <label>
                <i class="fas fa-play me-1"></i>
                Fecha de Inicio
              </label>
              <div class="form-text">
                <i class="fas fa-lightbulb text-warning me-1"></i>
                Fecha desde la cual esta regla comenzará a aplicarse
              </div>
              <div *ngIf="hasError('start_date')" class="text-danger small mt-1">
                {{ getErrorMessage('start_date') }}
              </div>
            </div>
          </div>
          <div class="col-6 mt-3">
            <div class="form-floating">
              <input (blur)="validateField('end_date')" 
                     [ngClass]="{'is-invalid': hasError('end_date')}" 
                     type="date" 
                     class="form-control" 
                     formControlName="end_date">
              <label>
                <i class="fas fa-stop me-1"></i>
                Fecha de Fin (Opcional)
              </label>
              <div class="form-text">
                <i class="fas fa-lightbulb text-warning me-1"></i>
                Fecha hasta la cual esta regla será válida. Déjelo vacío para vigencia indefinida
              </div>
              <div *ngIf="hasError('end_date')" class="text-danger small mt-1">
                {{ getErrorMessage('end_date') }}
              </div>
            </div>
          </div>
        </div>

        <!-- Configuración de Aplicación -->
        <div class="form-group col-12 mt-4">
          <div class="alert alert-info border-info">
            <div class="d-flex align-items-start">
              <i class="fas fa-cogs text-info me-2 mt-1"></i>
              <div>
                <h6 class="alert-heading mb-1">Configuración de Aplicación</h6>
                <small>Configure en qué procesos del sistema se aplicará esta penalidad</small>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-6 mt-3">
            <div class="card border-info">
              <div class="card-body p-3">
                <div class="d-flex align-items-center justify-content-between">
                  <div>
                    <label class="form-check-label fw-bold mb-1" for="applies_reactivation">
                      <i class="fas fa-redo text-info me-1"></i>
                      Aplica en Reactivación
                    </label>
                    <div class="text-secondary small">
                      Esta penalidad se reactivará automáticamente cuando el cliente realice el pago correspondiente y cumpla con las condiciones establecidas
                    </div>
                  </div>
                  <div class="form-check form-switch ms-3">
                    <input class="form-check-input fs-5" 
                           type="checkbox" 
                           formControlName="applies_reactivation"
                           id="applies_reactivation">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 mt-3">
            <div class="card border-warning">
              <div class="card-body p-3">
                <div class="d-flex align-items-center justify-content-between">
                  <div>
                    <label class="form-check-label fw-bold mb-1" for="applies_update_recalc">
                      <i class="fas fa-moon text-warning me-1"></i>
                      Aplica en Recálculo Nocturno
                    </label>
                    <div class="text-secondary small">
                      Esta penalidad se aplicará durante el proceso automático de recálculo nocturno del sistema
                    </div>
                  </div>
                  <div class="form-check form-switch ms-3">
                    <input class="form-check-input fs-5" 
                           type="checkbox" 
                           formControlName="applies_update_recalc"
                           id="applies_update_recalc">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>

      <!-- Botón para agregar regla -->
      <div class="form-group col-12 mt-4">
        <div class="d-grid gap-2" *ngIf="!editingRule">
          <button class="btn btn-success btn-lg" (click)="add()">
            <i class="fas fa-plus me-2"></i>
            Agregar Regla de Aplicación
          </button>
        </div>
        
        <!-- Botones cuando estamos editando -->
        <div class="row gap-2" *ngIf="editingRule">
          <div class="col-6">
            <div class="d-grid">
              <button class="btn btn-warning btn-lg" (click)="add()">
                <i class="fas fa-save me-2"></i>
                Actualizar Regla
              </button>
            </div>
          </div>
          <div class="col-6">
            <div class="d-grid">
              <button class="btn btn-secondary btn-lg" (click)="cancelEdit()">
                <i class="fas fa-times me-2"></i>
                Cancelar Edición
              </button>
            </div>
          </div>
        </div>
        
        <!-- Mensaje de edición -->
        <div class="alert alert-warning mt-2" *ngIf="editingRule">
          <div class="d-flex align-items-center">
            <i class="fas fa-edit text-warning me-2"></i>
            <small>
              <strong>Modo Edición:</strong> Está editando una regla existente. Modifique los campos necesarios y presione "Actualizar Regla" para guardar los cambios.
            </small>
          </div>
        </div>
      </div>

      <!-- Lista de reglas agregadas -->
      <div class="card border-secondary mt-3" *ngIf="listElements.length == 0">
        <div class="card-body text-center"> 
          <i class="fas fa-list-ul text-muted mb-2" style="font-size: 2rem;"></i>
          <h6 class="text-muted">No se han configurado reglas de aplicación</h6>
          <small class="text-secondary">Agregue al menos una regla para que la penalidad pueda aplicarse</small>
        </div>
      </div>

      <div class="row pt-3" *ngIf="listElements.length > 0">
        <div class="col-12 mb-3">
          <div class="alert alert-success border-success">
            <div class="d-flex align-items-center">
              <i class="fas fa-check-circle text-success me-2"></i>
              <h6 class="mb-0">Reglas Configuradas ({{ listElements.length }})</h6>
            </div>
          </div>
        </div>
        
        <div class="col-6" *ngFor="let elem of listElements">
          <div class="card mt-3" 
               [class.border-success]="!editingRule || editingRuleUuid !== elem?.uuid"
               [class.border-warning]="editingRule && editingRuleUuid === elem?.uuid"
               [class.shadow-lg]="editingRule && editingRuleUuid === elem?.uuid">
            <div class="card-header" 
                 [class.bg-success]="!editingRule || editingRuleUuid !== elem?.uuid"
                 [class.bg-warning]="editingRule && editingRuleUuid === elem?.uuid"
                 [class.bg-opacity-10]="true">
              <div class="d-flex justify-content-between align-items-center">
                <div class="fw-bold"
                     [class.text-success]="!editingRule || editingRuleUuid !== elem?.uuid"
                     [class.text-warning]="editingRule && editingRuleUuid === elem?.uuid">
                  <i class="fas fa-rule me-1"></i>
                  Regla #{{ elem?.uuid }}
                  <span *ngIf="editingRule && editingRuleUuid === elem?.uuid" class="badge bg-warning text-dark ms-2">
                    <i class="fas fa-edit me-1"></i>EDITANDO
                  </span>
                </div>
                <div>
                  <span class="badge bg-success me-2">Activa</span>
                  <button class="btn btn-sm btn-outline-primary me-1" 
                          (click)="editRule(elem?.uuid)"
                          title="Editar regla"
                          [disabled]="editingRule">
                    <i class="fas fa-edit"></i>
                  </button>
                  <button class="btn btn-sm btn-outline-danger" 
                          (click)="delete(elem?.uuid)"
                          title="Eliminar regla"
                          [disabled]="editingRule">
                    <i class="fas fa-trash"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="card-body">
              <!-- Condición -->
              <div class="d-flex justify-content-between align-items-start mb-2">
                <div class="text-secondary small">
                  <i class="fas fa-filter me-1"></i>
                  Condición:
                </div>
                <div class="fw-bold text-end">
                  {{ getValueByKey(list_fee_attributes,elem.attribute) }} 
                  {{ getValueByKey(list_comparison, elem.condition) }} 
                  <span *ngIf="elem.condition=='BETWEEN'" class="text-info">
                    {{ elem.lower_limit }} y {{ elem.upper_limit }}
                  </span> 
                  <span *ngIf="elem.condition!='BETWEEN'" class="text-info">
                    {{ elem.single_value }}
                  </span>
                </div>
              </div>

              <!-- Vigencia -->
              <div class="d-flex justify-content-between align-items-start mb-2">
                <div class="text-secondary small">
                  <i class="fas fa-calendar me-1"></i>
                  Vigencia:
                </div>
                <div class="fw-bold text-end small">
                  {{ elem.start_date | date: 'dd/MM/yyyy' }} 
                  <span *ngIf="elem.end_date"> hasta {{ elem.end_date | date: 'dd/MM/yyyy' }}</span>
                  <span *ngIf="!elem.end_date" class="text-success"> (Permanente)</span>
                </div>
              </div>

              <!-- Monto -->
              <div class="d-flex justify-content-between align-items-start mb-2">
                <div class="text-secondary small">
                  <i class="fas fa-dollar-sign me-1"></i>
                  Monto:
                </div>
                <div class="fw-bold text-success text-end">
                  {{ elem.currency }} {{ elem.fixed_amount }} 
                  <span *ngIf="elem.percentage"> + {{ elem.percentage }}%</span>
                </div>
              </div>

              <!-- Aplicación -->
              <div class="d-flex justify-content-between align-items-start" *ngIf="elem.applies_reactivation || elem.applies_update_recalc">
                <div class="text-secondary small">
                  <i class="fas fa-cogs me-1"></i>
                  Aplicación:
                </div>
                <div class="text-end">
                  <span *ngIf="elem.applies_reactivation" class="badge bg-info text-dark me-1">
                    <i class="fas fa-redo me-1"></i>Reactivación
                  </span>
                  <span *ngIf="elem.applies_update_recalc" class="badge bg-warning text-dark">
                    <i class="fas fa-moon me-1"></i>Recálculo
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- SECCIÓN 3: CUENTA CONTABLE -->
  <div class="card mt-3 border-warning">
    <div class="card-header bg-warning bg-opacity-10">
      <div class="d-flex align-items-center">
        <i class="fas fa-university text-warning me-2"></i>
        <h5 class="mb-0 text-warning">Cuenta Contable SAP</h5>
      </div>
      <small class="text-secondary mt-1 d-block">
        Seleccione la cuenta contable donde se registrarán los movimientos de esta penalidad
      </small>
    </div>
    <div class="card-body">
      <form [formGroup]="formAccount">
        <div class="row">
          <div class="col-12 mt-3">
            <div class="form-floating">
              <select class="form-select" 
                      formControlName="account" 
                      aria-label="Cuenta contable">
                <option value="">-- Seleccione la cuenta contable --</option>
                <option *ngFor="let cc of account_payments" [value]="cc._id">
                  {{ cc?.payment_method?.name }} - {{ cc?.subscriptor_cuenta }} - {{ cc?.subscriptor_simbolo }} - {{ cc?.subscriptor_mp }}
                </option>
              </select>
              <label for="account">
                <i class="fas fa-landmark me-1"></i>
                Cuenta Contable Vinculada
              </label>
              <div class="form-text">
                <i class="fas fa-lightbulb text-warning me-1"></i>
                Esta cuenta se usará para registrar contablemente los movimientos generados por esta penalidad en el sistema SAP
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

  <!-- BOTÓN FINAL -->
  <div class="d-grid gap-2 col-12 mx-auto mt-4 mb-4">
    <button type="button" 
            [disabled]="(!formInitial.valid || !formAccount.valid || listElements.length===0) || submit_disabled" 
            class="btn btn-primary btn-lg" 
            (click)="submit()">
      <span *ngIf="!submit_disabled">
        <i class="fas fa-save me-2"></i>
        <span *ngIf="code">Actualizar Penalidad</span>
        <span *ngIf="!code">Crear Nueva Penalidad</span>
      </span>
      <span *ngIf="submit_disabled">
        <i class="fa fa-spinner fa-spin me-2"></i>
        Procesando...
      </span>
    </button>
  </div>